var React = require('react');

function FacebookLogoInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"icons8-facebook","d":"M49.99,3a46.962,46.962,0,0,0-7.025,93.4V62.442H31.339V50.092H42.965V41.873c0-13.608,6.63-19.579,17.938-19.579a65.961,65.961,0,0,1,9.637.583v10.78H62.826c-4.8,0-6.477,4.554-6.477,9.684v6.751h14.07L68.512,62.442H56.349V96.5A46.964,46.964,0,0,0,49.99,3Z","transform":"translate(-3 -3)","fill":"currentColor"}));
}

FacebookLogoInline.defaultProps = {"viewBox":"0 0 93.98 93.499"};

module.exports = FacebookLogoInline;

FacebookLogoInline.default = FacebookLogoInline;
